export default "__VITE_ASSET__Bqaz6DjP__"